import {Component, ElementRef, ViewChild} from '@angular/core';
import {Events, Modal, ModalController, ModalOptions, Nav} from 'ionic-angular';
import {Platform, MenuController} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {Location} from '@angular/common';

import {MenuProvider} from '../providers/menu/menu';
import {AuthenticationProvider} from '../providers/authentication';
import {LoginPage} from '../pages/login/login';
import {ConstantProvider} from "../providers/constants";
import {SettingsProvider} from "../providers/settings";
import {LoaderProvider} from "../providers/loader";
import {ApiProvider} from "../providers/api/api";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  pages: any;
  qtdAlert:number = 0;

  // Selected Side Menu
  selectedMenu: any;
  visibility: string = 'hidden';

  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  infouser: any;

  constructor(
    public platform: Platform,
    statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public auth: AuthenticationProvider,
    public set: SettingsProvider,
    public menuProvider: MenuProvider,
    private location: Location,
    public events: Events,
    private api: ApiProvider,
    public loader: LoaderProvider,
    public modalCtrl: ModalController,
    public constants: ConstantProvider,
    public menu: MenuController
  ) {
    this.rootPage = "LoginPage";
    this.getSideMenuData();

    events.subscribe('reload:evChecaLogado', () => {
      this.checaLogado();
    });

    events.subscribe('reload:getInfoUser', () => {
      this.getInfoUser();
    });

    events.subscribe('reload:fnLogout', () => {
      this.exitRefresh();
    });

    this.getInfoUser();
    this.menu.enable(false);

    let me = this;
    setInterval(function () {
      api.obter('getQtdAlert').then((data: any) => {
        if(data != undefined) {
          me.qtdAlert = data;
        }
      });
    }, 60000);

    // if (!navigator.onLine) {
    //
    // }
  }

  getSideMenuData() {
    this.pages = this.menuProvider.getSideMenus();
  }

  getInfoUser() {
    this.set
      .loadSetting("infouser")
      .then((data: any) => {
        this.infouser = data;
      });
  }

  exitRefresh() {
    this.exit();
    setTimeout(function () {
      location.reload();
    }, 1000);
  }

  checaLogado() {
    this.auth
      .loadUserCredentials()
      .then(res => {
        if (res == undefined || !this.auth.authenticated) {
          if (document.URL.indexOf("login") == -1) {
            this.exit();
          }
        }
      });
  }

  exit() {
    this.clearCache();
    this.nav.setRoot('LoginPage');
  }

  clearCache() {
    this.auth.destroyUserCredentials();
    this.menu.enable(false, 'authenticated');
  }

  openPage(p, index) {
    if (p.page) {
      this.auth
        .loadUserCredentials()
        .then(res => {
          if (res == undefined || !this.auth.authenticated) {
            this.nav.setRoot('LoginPage');
          } else {
            if (p.page == "exitPage") {
              this.exit();
            } else {
              this.nav.setRoot(p.page);
            }
          }
          this.menu.close();
        });
    } else {
      if (this.selectedMenu) {
        this.selectedMenu = 0;
      } else {
        this.selectedMenu = index;
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts